import { render, staticRenderFns } from "./NotPermission.vue?vue&type=template&id=68652342&scoped=true"
import script from "./NotPermission.vue?vue&type=script&lang=js"
export * from "./NotPermission.vue?vue&type=script&lang=js"
import style0 from "./NotPermission.vue?vue&type=style&index=0&id=68652342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68652342",
  null
  
)

export default component.exports